const checkoutTools = {
    openPhoneHrader: function (btn) {
        btn.toggleClass('open');
        btn.closest('div').find('.js__header_checkout_phone_list').slideToggle('slow');
    },

    closePhoneHeader: function () {
        $('.js__header_checkout_phone_btn').removeClass('open');
        $('.js__header_checkout_phone_list').slideUp('slow');
    },

    openSelect: function (btn) {
        btn.addClass('open');
        btn.closest('div').find('.js__select_list_checkout').slideDown('slow');
    },

    changeSelect: function (btn) {
        const type = btn.attr('data-type');
        this.updateSelectType(btn, type);
        this.closeSelect();
    },

    updateSelectType: function (btn, type) {
        switch (type) {
            case 'counterparty':
                this.updateCounterparty(btn);
                break;

            case 'addresses':
                this.updateAddresses(btn);
                break;

            case 'new_post':
                this.updateNewPost(btn);
                break;

            case 'delivery_companies':
                this.updateDeliveryCompany(btn);
                break;

            case 'offices':
                this.updateOffices(btn);
                break;

            case 'save_delivery':
                this.updateSaveDelivery(btn);
                break;
        }
    },

    updateSaveDelivery: function (btn) {
        const name = btn.text().trim();
        const wrapper = btn.closest('.input_select_wrapper_checkout');
        const selectBtn = wrapper.find('.js__select_btn_checkout');

        wrapper.find('.js__select_item_checkout').removeClass('active');
        btn.addClass('active');

        selectBtn.empty().text(name);

        const typeDelivery = btn.attr('data-type_delivery');
        const typeAnotherMan = btn.attr('data-another_man');
        const cityGuid = btn.attr('data-city_guid');

        if (cityGuid != '') {
            $(`.js__select_item_checkout[data-city_guid=${cityGuid}]`).first().trigger('click');
        }

        $(`.js__input_radio_checkout[data-type_delivery=${typeDelivery}]`).trigger('click');
        typeAnotherMan == 'my' ? '' : $(`.js__another_man_btn`).first().trigger('click');

        switch (typeDelivery) {
            case '2660':
                const addressId = btn.attr('data-address_id');
                $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}] .js__select_item_checkout[data-addresses_id=${addressId}]`)
                    .first().trigger('click');
                break;

            case '2661':
                const addressDelivery2661 = btn.attr('data-address_delivery');
                $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}] input[name=post_number]`)
                    .first().val(addressDelivery2661);
                break;

            case '2663':
                const addressDelivery2663 = btn.attr('data-address_delivery');
                $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}]  input[name=post_number]`)
                    .first().val(addressDelivery2663);
                break;

            case '2662':
                const companyId = btn.attr('data-company_id');
                $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}]  .js__select_item_checkout[data-delivery_company_id=${companyId}]`)
                    .first().trigger('click');

                switch (companyId) {
                    case '60495':
                        const officeId60495 = btn.attr('data-office_id');
                        $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}]  .js__office_select_item[data-delivery_company_id=${companyId}][data-post_unit_id=${officeId60495}]`)
                            .first().trigger('click');
                        break;

                    case '90465':
                        const officeId90465 = btn.attr('data-office_id');
                        $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}]  .js__office_select_item[data-delivery_company_id=${companyId}][data-post_unit_id=${officeId90465}]`)
                            .first().trigger('click');
                        break;

                    case '116529':
                        const officeId116529 = btn.attr('data-office_id');
                        $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}]  .js__office_select_item[data-delivery_company_id=${companyId}][data-post_unit_id=${officeId116529}]`)
                            .first().trigger('click');
                        break;

                    case '120420':
                        const officeGuid = btn.attr('data-office_guid');
                        $(`.input_radio_delivery_wrapper_checkout[data-type_delivery=${typeDelivery}]  .js__office_select_item[data-delivery_company_id=${companyId}][data-post_unit_guid=${officeGuid}]`)
                            .first().trigger('click');
                        break;
                }

                break;
        }

        if (typeAnotherMan == 'another_man') {
            const lastNameAnotherMan = btn.attr('data-last_name_another_man');
            const firstNameAnotherMan = btn.attr('data-first_name_another_man');
            const fatherNameAnotherMan = btn.attr('data-father_name_another_man');
            let phoneAnotherMan = btn.attr('data-phone_another_man');
            const emailAnotherMan = btn.attr('data-email_another_man');

            phoneAnotherMan = phoneAnotherMan.split('380').join('');

            $(`.another_man_wrapper_checkout input[name="last_name_another_man"]`).val(lastNameAnotherMan);
            $(`.another_man_wrapper_checkout input[name="first_name_another_man"]`).val(firstNameAnotherMan);
            $(`.another_man_wrapper_checkout input[name="father_name_another_man"]`).val(fatherNameAnotherMan);
            $(`.another_man_wrapper_checkout input[name="phone_another_man"]`).val(phoneAnotherMan);
            $(`.another_man_wrapper_checkout input[name="email_another_man"]`).val(emailAnotherMan);
        } else {
            $(`.data_contact_details_order[data-typeContacDtetailsOrder="another_man"] input`).val('');
        }
    },

    updateOffices: function (btn) {
        const name = btn.text().trim();
        const postNumber = typeof btn.attr('data-post_number') != 'undefined' ? btn.attr('data-post_number') : '';
        const city = typeof btn.attr('data-city') != 'undefined' ? btn.attr('data-city') : '';
        const cityId = typeof btn.attr('data-city_id') != 'undefined' ? btn.attr('data-city_id') : '';
        const postUnitGuid = typeof btn.attr('data-post_unit_guid') != 'undefined' ? btn.attr('data-post_unit_guid') : '';
        const postUnitId = btn.attr('data-post_unit_id');
        const deliveryCompanyId = btn.attr('data-delivery_company_id');
        const wrapper = btn.closest('.input_select_wrapper_checkout');
        const selectBtn = wrapper.find('.js__select_btn_checkout');
        const inputPostUnitId = wrapper.find('input[name=post_unit_id]');
        const inputPostUnitGuid = wrapper.find('input[name=post_unit_guid]');
        const inputPostNumber = wrapper.find('input[name=post_number]');
        const inputCity = wrapper.find('input[name=city]');
        const inputCityId = $('input[name="city_id"]');

        wrapper.find('.js__select_item_checkout').removeClass('active');
        btn.addClass('active');

        wrapper.find('input[type=hidden]').removeClass('required')

        inputPostUnitId.val(postUnitId);
        inputCity.val(city);
        inputPostNumber.val(postNumber);
        inputPostUnitGuid.val(postUnitGuid);
        selectBtn.empty().text(name);

        inputCityId.val() == '' ? inputCityId.val(cityId) : null;
    },

    updateDeliveryCompany: function (btn) {
        const name = btn.text().trim();
        const deliveryCompanyId = btn.attr('data-delivery_company_id');
        const wrapper = btn.closest('.input_select_wrapper_checkout');
        const selectBtn = wrapper.find('.js__select_btn_checkout');
        const inputDeliveryCompanyId = wrapper.find('input[name=delivery_company_id]');
        const newPostCityId = $('input[name=city_id]').val();


        wrapper.find('.js__select_item_checkout').removeClass('active');
        btn.addClass('active');

        inputDeliveryCompanyId.val(deliveryCompanyId);
        selectBtn.empty().text(name);


        const selectOfficeBtn = $('.js__select_office_btn');
        const defaultName = selectOfficeBtn.attr('data-text_default').trim();
        selectOfficeBtn.empty().text(defaultName)
        selectOfficeBtn.prop('disabled', false)
        $('.js__office_select_item').hide();

        if (deliveryCompanyId != 120420) {
            $('.js__cod').addClass('d_none_bootstrap');
            $(`.js__office_select_item[data-delivery_company_id=${deliveryCompanyId}]`).show();

            if ($('.js__cod input').is(':checked')) {
                $('input[data-type_payment=4]').trigger('click');
            }

            $('input[name=post_unit_id]').val('');
            $('input[name=post_number]').val('');
            $('input[name=city]').val('');
        } else {
            $('.js__cod').removeClass('d_none_bootstrap');

            if (newPostCityId) {
                $(`.js__office_select_item[data-delivery_company_id=${deliveryCompanyId}][data-new_post_city_id=${newPostCityId}]`).show()
            } else {
                $(`.js__office_select_item[data-delivery_company_id=${deliveryCompanyId}]`).show()
            }
        }
    },

    updateNewPost: function (btn) {
        const name = btn.text().trim();
        const cityId = btn.attr('data-city_id');
        const cityGuid = btn.attr('data-city_guid');
        const wrapper = btn.closest('.input_select_wrapper_checkout');
        const inputBtn = wrapper.find('.js__select_search_checkout');
        const inputCityId = wrapper.find('input[name=city_id]');
        const inputCityGuid = wrapper.find('input[name=city_guid]');

        wrapper.find('.js__select_item_checkout').removeClass('active');
        btn.addClass('active');

        inputCityId.val(cityId);
        inputCityGuid.val(cityGuid);
        inputBtn.val(name);

        toolsDeliveryCheckout.updateDeliveryInput(cityId, name);
    },

    updateAddresses: function (btn) {
        const name = btn.text().trim();
        const addressesId = btn.attr('data-addresses_id');
        const wrapper = btn.closest('.input_select_wrapper_checkout');
        const selectBtn = wrapper.find('.js__select_btn_checkout');
        const inputAddressesId = wrapper.find('input[name=branches_pickup]');

        wrapper.find('.js__select_item_checkout').removeClass('active');
        btn.addClass('active');

        inputAddressesId.val(addressesId);
        selectBtn.empty().text(name);
    },

    updateCounterparty: function (btn) {
        const name = btn.text().trim();
        const counterpartyGuid = btn.attr('data-counterparty_guid');
        const vatPayer = btn.attr('data-vat_payer');
        const wrapper = btn.closest('.input_select_wrapper_checkout');
        const selectBtn = wrapper.find('.js__select_btn_checkout');
        const inputCounterpartyGuid = wrapper.find('input[name=counterparty_guid]');
        const vatPayerBlock = $('.js__vat_payer_block');

        wrapper.find('.js__select_item_checkout').removeClass('active');
        btn.addClass('active')

        inputCounterpartyGuid.val(counterpartyGuid);
        selectBtn.empty().text(name);

        vatPayer == 1 ? vatPayerBlock.removeClass('d_none_bootstrap') : vatPayerBlock.addClass('d_none_bootstrap');
        vatPayerBlock.find('input[name=vat_payer]').prop('checked', vatPayer == 1 ? true : false).trigger('change');
    },

    searchSelect: function (input) {
        let query = input.val().trim().toLowerCase();
        const wrapper = input.closest('.input_select_wrapper_checkout');
        const selectBtn = wrapper.find('.js__select_item_checkout');
        const items = selectBtn.closest('.input_item_select_checkout');
        let count = 0;

        if (query.length > 2) {
            selectBtn.each(function (index) {
                const cityName = $(this).text().trim().toLowerCase();
                const item = items.eq(index);
                if (cityName.startsWith(query)) {
                    item.show();
                    count++;
                } else {
                    item.hide();
                }
            });
        } else {
            items.hide();
        }

        if (count > 0) {
            if (!input.hasClass('open')) {
                checkoutTools.openSelect(input);
            }
        } else {
            checkoutTools.closeSelect();
        }
    },

    searchSelectItem: function (input) {
        let query = input.val().trim().toLowerCase();
        const wrapper = input.closest('.js__select_list_checkout');
        const deliveryCompanyId = $('input[name=delivery_company_id]').val();
        const newPostCityId = $('input[name=city_id]').val();
        const items = deliveryCompanyId != 120420
            ? wrapper.find(`.js__select_item_checkout[data-delivery_company_id=${deliveryCompanyId}]`)
            : wrapper.find(`.js__office_select_item[data-delivery_company_id=${deliveryCompanyId}][data-new_post_city_id=${newPostCityId}]`).show();

        let count = 0;

        if (query.length > 1) {
            items.each(function () {
                const item = $(this);
                const officeName = $(this).text().trim().toLowerCase();

                if (officeName.includes(query)) {
                    item.show();
                    count++;
                } else {
                    item.hide();
                }
            });
        } else {
            items.show();
        }
    },

    closeSelect: function () {
        $('.js__select_btn_checkout, .js__select_search_checkout').removeClass('open');
        $('.js__select_list_checkout').slideUp('slow');
    },

    changePriset: function (btn) {
        const prisetId = btn.attr('data-priset_id');
        $(`.js__select_item_checkout[data-type=new_post][data-city_id=${prisetId}]`).trigger('click');
    },

    updateVat: function () {
        const totalSum = parseFloat($('.js__main_price_checkout .js__update_total_sum').first().text().replace(/\s+/g, ''));
        const vatSum = totalSum * 0.2;
        $('.js__sum_vat').text(this.formatNumber(totalSum));
        $('.js__vat').text(this.formatNumber(vatSum));
        $('.js__total_sum_vat').text(this.formatNumber(totalSum + vatSum));
    },

    formatNumber: function (num) {
        return Math.ceil(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    toggleMainSum: function (isChecked) {
        const vatPrice = $('.js__main_price_checkout[data-type=vat]');
        const mainPrice = $('.js__main_price_checkout[data-type=main]');
        const inputLocPayment = $('input[data-type_payment=3]')
            .closest('.input_radio_wrapper_checkout')

        if (isChecked) {
            vatPrice.removeClass('d_none_bootstrap');
            mainPrice.addClass('d_none_bootstrap');
            this.updateVat();

            inputLocPayment.addClass('d_none_bootstrap');
            $('input[data-type_payment=4]').trigger('click');
        } else {
            vatPrice.addClass('d_none_bootstrap');
            mainPrice.removeClass('d_none_bootstrap');

            inputLocPayment.removeClass('d_none_bootstrap');
            $('input[data-type_payment=4]').trigger('click');
        }
    },

    openMiniMenu: function (btn) {
        btn.toggleClass('open');
        $('.js__append_mini_cart').slideToggle('slow');
    },

    openModelCheckout: function () {
        $.post(request.openModelCheckout, {}, function (data) {
            if (data.status == 'success') {
                if ($('.js__bg_modal_checkout').length == 0) {
                    $('footer').after('<div class="bg_modal_checkout js__bg_modal_checkout"></div>')
                    $('footer').after(data.html);
                }
            }
        })
    }
};


$(document).ready(function () {
    $(document).on('click', '.js__open_edit_cart', function () {
        checkoutTools.openModelCheckout();
    })

    $(document).on('click', '.js__close_cart_checkout, .js__bg_modal_checkout', function () {
        $('.js__bg_modal_checkout').remove();
        $('.cart_model_checkout').remove();
    })

    $(document).on('click', '.js__header_checkout_phone_btn', function () {
        checkoutTools.openPhoneHrader($(this));
    })

    $(document).on('click', function (e) {
        if ($('.js__header_checkout_phone_btn').hasClass('open')) {
            if (!$(e.target).closest('.header_checkout_phone').length) {
                checkoutTools.closePhoneHeader();
            }
        }
    });

    $(document).on('click', '.js__select_btn_checkout', function (e) {
        const btn = $(this);

        if (btn.hasClass('open')) {
            checkoutTools.closeSelect();
        } else {
            checkoutTools.closeSelect();
            checkoutTools.openSelect(btn);
        }

        sendOrderTools.closeError(btn.closest('.input_wrapper_checkout'), 'main');
        e.stopPropagation();
    });

    $(document).on('click', '.js__select_item_checkout', function () {
        const btn = $(this);
        checkoutTools.changeSelect(btn);
    });

    $(document).on('input', '.js__select_search_checkout', function () {
        const input = $(this);
        checkoutTools.searchSelect(input);
    })

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.input_select_wrapper_checkout').length) {
            checkoutTools.closeSelect();
        }
    });

    $(document).on('click', '.js__active_priset', function () {
        const btn = $(this);
        checkoutTools.changePriset(btn);
    });

    $(document).on('change', '.js__vat_payer_block input[name=vat_payer]', function () {
        const isChecked = $(this).is(':checked');

        checkoutTools.toggleMainSum(isChecked);
    });

    $(document).on('click', '.js__open_mini_cart', function () {
        const btn = $(this);
        checkoutTools.openMiniMenu(btn);
    })

    $(document).on('click', '.js__open_btn_comment', function () {
        $(window).outerHeight() > 768 ? $('.js__open_comment').slideToggle('slow') : null
    })

    $(document).on('input', '.js__search_item_for_select', function () {
        const input = $(this);
        checkoutTools.searchSelectItem(input);
    })
})

window.updateVatPrice = checkoutTools.updateVat;

const toolsDeliveryCheckout = {
    openDelivery: function (input) {
        const wrapper = input.closest('.input_radio_delivery_wrapper_checkout');
        const deliveryInputField = wrapper.find('.delivery_type_checkbox');
        const inputs = deliveryInputField.find('input[type=text]:not(.js__another_man_input), input[type=hidden]');
        const costDelivery = wrapper.find('.js__cost_delivery');
        const totalDeliveryBlock = $('.js__update_delivery_sum');
        const totalWrapperBlockDevicery = totalDeliveryBlock.closest('.order_total_info_item_checkout');

        wrapper.addClass('active_delivery');
        deliveryInputField.slideDown('slow');
        inputs.addClass('required').attr('data-type_error', 'main');

        if (costDelivery.length > 0) {
            const cost = costDelivery.text().trim();
            totalDeliveryBlock.empty().text(cost);
            totalWrapperBlockDevicery.removeClass('d_none_bootstrap')
        } else {
            totalDeliveryBlock.empty();
            totalWrapperBlockDevicery.addClass('d_none_bootstrap')
        }
    },

    closeDelivery: function () {
        const wrapper = $('.input_radio_delivery_wrapper_checkout.active_delivery');
        if (wrapper.length > 0) {
            const deliveryInputField = wrapper.find('.delivery_type_checkbox');
            const inputs = deliveryInputField.find('input[type=text], input[type=hidden]');

            wrapper.removeClass('active_delivery');
            deliveryInputField.slideUp('slow');
            inputs.removeClass('required').attr('data-type_error', '');
        }
    },

    openAnotherMan: function (input) {
        if (input.is(':checked')) {
            $('.js__another_man_btn').val('another_man');
            $('.js__another_man_btn').prop('checked', true);

            $('.another_man_checkout').slideDown('slow');
            $('.js__another_man_input[data-required=true]').addClass('required').attr('data-type_error', 'main');
        } else {
            $('.js__another_man_btn').val('my');
            $('.js__another_man_btn').prop('checked', false);

            $('.another_man_checkout').slideUp('slow');
            $('.js__another_man_input[data-required=true]').removeClass('required').attr('data-type_error', '');
        }
    },

    blurAnotherMan: function (input) {
        const name = input.attr('name');
        const value = input.val();

        $(`input[name=${name}]`).val(value);
    },

    saveDelivery: function (btn) {
        btn.toggleClass('active');
        if (btn.hasClass('active')) {
            $('input[name=is_save_delivery]').val(1);
            $('.js__save_delivery_btn').addClass('active');
        } else {
            $('input[name=is_save_delivery]').val(0);
            $('.js__save_delivery_btn').removeClass('active');
        }
    },

    updateDeliveryInput: function (cityId, name) {
        const mainCity = { 3452: 1418, 8854: 1228, 2340: 1440, 4577: 1333, 5949: 1545 };
        const deliveryForMainCity = $('.input_radio_delivery_wrapper_checkout[data-type_delivery=2660], .input_radio_delivery_wrapper_checkout[data-type_delivery=2661]');

        if (mainCity[cityId]) {
            deliveryForMainCity.removeClass('d_none_bootstrap');
            this.activeCityForDelivery2660(mainCity[cityId]);
            this.activeCityForDelivery2661(mainCity[cityId], name);
        } else {
            deliveryForMainCity.each(function () {
                const wrapper = $(this);
                const checkbox = wrapper.find('input[type="radio"]:checked');
                if (checkbox.length > 0) {
                    $('.js__input_radio_checkout[name=delivery][data-type_delivery=2662]').trigger('click');
                }
                wrapper.addClass('d_none_bootstrap');
            });
        }

        this.activeCityForDelivery2663(name);
        this.activeCityForDelivery2662(cityId);
    },

    activeCityForDelivery2660: function (mainCityId) {
        const wrapper = $('.input_radio_delivery_wrapper_checkout[data-type_delivery=2660]');
        const selectItems = wrapper.find('.js__select_item_checkout[data-type=addresses]');
        const cityItems = selectItems.filter(`[data-city_id=${mainCityId}]`);

        selectItems.closest('.input_item_select_checkout').hide();
        cityItems.closest('.input_item_select_checkout').show();

        if (cityItems.length == 1) {
            cityItems.trigger('click');
        } else {
            const selectBtn = wrapper.find('.js__select_btn_checkout');
            const defaultName = selectBtn.attr('data-text_default').trim();
            selectBtn.empty().text(defaultName);
            wrapper.find('input[name=branches_pickup]').val('');
        }
    },

    activeCityForDelivery2661: function (mainCityId, name) {
        const wrapper = $('.input_radio_delivery_wrapper_checkout[data-type_delivery=2661]');
        const input = wrapper.find('input[name=post_number]');
        const costTextBlock = wrapper.find('.js__cost_delivery_update');
        const workTimeTextBlock = wrapper.find('.js__delivery_city_checkbox');

        const workDeliveryAndCost = {
            1228: {
                'work_time': 'пн-пт: 09:30, 12:30, 14:00 <br> сб: 9:10, 11:10',
                'cost': '100 грн',
            },
            1333: {
                'work_time': 'пн-пт: 10:00, 13:30, 16:30 <br> сб: 9:30, 12:00',
                'cost': '100 грн',
            },
            1418: {
                'work_time': 'пн-пт: 10:00, 13:00, 15:00, <br> сб: 10:00, 12:00',
                'cost': '200 грн',
            },
            1545: {
                'work_time': 'пн-пт: 10:00, 13:00, 15:00 <br> сб: 10:00, 12:30',
                'cost': '200 грн',
            },
            1440: {
                'work_time': 'пн-пт: 10:00, 13:00, 15:00 <br>сб: 10:00, 12:30',
                'cost': '200 грн',
            },
        };

        input.empty().val(`${name}, `);
        costTextBlock.find('span').empty().text(workDeliveryAndCost[mainCityId].cost);
        workTimeTextBlock.empty().html(workDeliveryAndCost[mainCityId].work_time);
        $('.js__update_delivery_sum').empty().text(costTextBlock.text());
    },

    activeCityForDelivery2663: function (name) {
        const wrapper = $('.input_radio_delivery_wrapper_checkout[data-type_delivery=2663]');
        const input = wrapper.find('input[name=post_number]');

        input.empty().val(`${name}, `);
    },

    activeCityForDelivery2662: function (newPostCityId) {
        const wrapper = $('.input_radio_delivery_wrapper_checkout[data-type_delivery=2662]');
        const deliveryCompanyId = wrapper.find('input[name=delivery_company_id]').val();

        if (deliveryCompanyId == 120420) {
            $('.js__office_select_item').hide();
            $(`.js__office_select_item[data-delivery_company_id=${deliveryCompanyId}][data-new_post_city_id=${newPostCityId}]`).show();
        }
    },

    activeTypeDelivery: function (btn) {
        $('.js__type_delivery_block').removeClass('active');
        $('.block_delivery_checkout').addClass('d_none_bootstrap');

        const type = btn.attr('data-type');

        btn.addClass('active');
        $(`.block_delivery_checkout[data-type=${type}]`).removeClass('d_none_bootstrap');
    }
}

$(document).ready(function () {
    $(document).on('click', '.js__type_delivery_block', function () {
        const btn = $(this);
        toolsDeliveryCheckout.activeTypeDelivery(btn);
    });

    $(document).on('click', '.js__input_radio_checkout', function () {
        const input = $(this);
        const wrapper = input.closest('.input_radio_delivery_wrapper_checkout');
        wrapper.hasClass('active_delivery') ? null : toolsDeliveryCheckout.closeDelivery();
        toolsDeliveryCheckout.openDelivery(input);
    });

    $(document).on('click', '.js__another_man_btn', function () {
        const input = $(this);
        toolsDeliveryCheckout.openAnotherMan(input);
    })

    $(document).on('blur', '.js__another_man_input', function () {
        const input = $(this);
        toolsDeliveryCheckout.blurAnotherMan(input);
    })

    $(document).on('click', '.js__save_delivery_btn', function () {
        const btn = $(this);
        toolsDeliveryCheckout.saveDelivery(btn);
    })
})

const sendOrderTools = {
    clearAllErrors: function () {
        $('.input_wrapper_checkout').removeClass('error_active');
        $('.input_error_checkout[data-type_error=main]').hide();
    },

    isValidEmail: function (email) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    },

    showError: function (wrapper, selector) {
        wrapper.addClass('error_active');
        wrapper.find(`.input_error_checkout[data-type_error=${selector}]`).slideDown('slow');
    },

    closeError: function (wrapper, selector) {
        if (wrapper.hasClass('error_active')) {
            wrapper.removeClass('error_active');
            wrapper.find(`.input_error_checkout[data-type_error=${selector}]`).slideUp('slow');
        }
    },

    loaderForm: function (status) {
        if (status === 'start') {
            $('.js__send_order_btn').prop('disabled', true);
            $('.preloader_wrapper').show().css('opacity', 1);
        } else {
            $('.js__send_order_btn').prop('disabled', false);
            removePreloader();
        }
    },

    sendCheckout: function (objectCheckout) {

        let total_price = $('.js__total_block .not_vat_payment .js__value span').text().split(' ').join('');
        const totla_goods = [];
        const cartGoodGuids = toolsCartGoodsBuy.getGoods();

        for (const value of cartGoodGuids) {
            let dataGood = JSON.parse(localStorage.getItem(value));
            if (dataGood && dataGood.length > 0) {
                dataGood[0]['quantity'] = dataGood[1]['quantity']
                totla_goods.push(dataGood[0]);
            }
        }

        $.post(request.sendCheckout, objectCheckout, function (data) {
            if (data.status == 'ok') {
                $('.js__send_order, .order_total_send_checkout, .js__open_edit_cart, .order_total_info_item_checkout[data-type=total]').remove();
                $('.js__success_send').removeClass('d_none_bootstrap');
                sendOrderTools.loaderForm('stop');
                $('.js__order_num').empty().text(data.id);

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "purchase",
                    ecommerce: {
                        transaction_id: `${data.id}`,
                        affiliation: tupeSend,
                        value: `${total_price}`,
                        currency: "UAH",
                        items: totla_goods
                    }
                });

                for (const value of cartGoodGuids) {
                    localStorage.removeItem(value);
                }
                scrollTop();
            }

            if (data.status == 'success_monopay') {
                const update_remains_gtm = data.update_remains_gtm;

                for (const value of update_remains_gtm) {
                    const objGood = value;

                    let dataGood = JSON.parse(localStorage.getItem(objGood.id));

                    if (dataGood && Array.isArray(dataGood) && dataGood.length > 0) {
                        dataGood[0]['quantity'] = objGood.quantity;
                        dataGood[1]['quantity'] = objGood.quantity;

                        localStorage.setItem(objGood.id, JSON.stringify(dataGood));
                    }
                }

                window.location.href = data.href;
            }

            if (data.status == 'quantity_exceeds_stock') {
                sendOrderTools.loaderForm('stop');

                if ($('.bg_modal_quantity_exceeds_stock').length == 0) {
                    $('footer').append('<div class="bg_modal_quantity_exceeds_stock"></div>');
                }
                $('footer').after(data.html);
            }

            if (data.status == 'error_monopay') {
                sendOrderTools.loaderForm('stop');

                if ($('.bg_modal_monopay').length == 0) {
                    $('footer').append('<div class="bg_modal_monopay"></div>');
                }
                $('.modal_wrap[data-modal="errorMonoPay"]').addClass('js_open_modal');

                setTimeout(function () {
                    location.reload();
                }, 2000);
            }
        });
    },

    updateLocalStorage: function (input) {
        var name = input.attr('name');
        var value = input.val();

        var storedData = JSON.parse(localStorage.getItem(nameLocalStorage)) || {};

        storedData[name] = value;

        localStorage.setItem(nameLocalStorage, JSON.stringify(storedData));
    },

    getLocalStorage: function () {
        let storedJson = localStorage.getItem(nameLocalStorage);
        let storedValues = storedJson ? JSON.parse(storedJson) : {};

        $('.input_input_checkout[data-save_local=true]').each(function () {
            const input = $(this);
            const name = input.attr('name');

            if (!storedValues[name]) {
                storedValues[name] = input.val();
            } else {
                input.val(storedValues[name]);
            }
        });

        localStorage.setItem(nameLocalStorage, JSON.stringify(storedValues));
    }

}

$(document).ready(function () {
    sendOrderTools.getLocalStorage();

    $(document).on('input', '.input_input_checkout.required', function () {

        const input = $(this);
        sendOrderTools.closeError(input.closest('.input_wrapper_checkout'), 'main')
    });

    $(document).on('submit', '.js__send_checkout', function (e) {
        e.preventDefault();

        const form = $(this);
        const objectData = {
            'type_order': 'main',
            'lang': lang,
            'sbjs': objectSbjs,
        };

        sendOrderTools.clearAllErrors();
        let error = 0;

        form.find('input[type=text]:not(.js__another_man_input, .js__delivery_input), textarea').each(function () {
            const input = $(this);
            const name = input.attr('name');
            const wrapper = input.closest('.input_wrapper_checkout');
            const type = input.attr('type');
            let value = input.val().trim();

            if (name) {
                if (input.hasClass('required') && value === '') {
                    sendOrderTools.showError(wrapper, 'main');
                    error++;
                } else {
                    if (input.hasClass('required')) {
                        if (name === 'phone') {
                            value = value.replace(/\D/g, '');
                            if (value === '') {
                                sendOrderTools.showError(wrapper, 'main');
                                error++;
                            }
                        }
                    }

                    objectData[name] = value;
                }
            }
        });

        objectData['city_id'] = $('input[name=city_id]').val();
        objectData['counterparty_guid'] = $('input[name=counterparty_guid]').length > 0 ? $('input[name=counterparty_guid]').val() : undefined;

        form.find('input[type=radio]:checked').each(function () {
            const input = $(this);
            const name = input.attr('name');
            const wrapper = input.closest('.input_wrapper_checkout');
            let value = input.val();

            wrapper.find('input').each(function () {
                const inputChild = $(this);
                const nameChild = inputChild.attr('name');
                const wrapperChild = inputChild.closest('.input_wrapper_checkout');
                let valueChild = inputChild.val();

                if (nameChild) {
                    if (inputChild.hasClass('required') && valueChild === '') {
                        sendOrderTools.showError(wrapperChild, 'main');
                        error++;
                    } else {
                        objectData[nameChild] = valueChild;
                    }
                }
            })

            objectData[name] = value;
        });

        form.find('input[type=checkbox]').each(function () {
            const input = $(this);
            const name = input.attr('name');
            let value = '';
            if (name == 'contact_details_order') {
                value = input.val();
            } else {
                value = input.is('checked') ? 1 : 0;
            }

            objectData[name] = value;
        });

        if (error == 0) {
            sendOrderTools.loaderForm('start');
            sendOrderTools.sendCheckout(objectData);
        }
    });

    $(document).on('blur', '.input_input_checkout[data-save_local=true]', function () {
        const input = $(this);
        sendOrderTools.updateLocalStorage(input);
    });
})